<template>
	<div class="vx-col w-full mb-base" ref="popupContainer">
		<span>
			<ContractInfoPopup
				:contract="selectedContract"
				:popupActive.sync="showContractPopup"
			/>
		</span>
		<vs-popup
			:active.sync="showMaxBudgetPurchasePopup"
			title="Somme des achats pour la période par prestataire"
			v-show="!showContractPopup && showMaxBudgetPurchasePopup"
		>
			<!-- PurchasesTableRecapProviders -->
			<PurchasesTableRecapBudgetMediaMax
				:purchases="displayedPurchasesFull"
				:apiUrl="apiUrl"
				@contract-info-popup="displayContractInfoPopup($event)"
			/>
		</vs-popup>
		<FilterCard
			:refreshKey="1"
			:key="refreshKey"
			:showRowNum="false"
			:filters="filtersTemplates"
			:showListLength="displayedPurchases.length"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>

		<vx-card style="max-height: 79vh; overflow: auto" class="click-to-add">
			<div id="researchContainer" :style="loaderStyle"></div>
			<vs-tabs v-model="currentTab">
				<vs-tab label="Vue en Tableau">
					<div ref="purchaseTable" v-if="currentTab == 0">
						<PurchasesTable
							v-if="currentTab == 0"
							:purchases="displayedPurchases"
							:loading="loading"
							:editFacturation="editFacturation"
							@delete-line="removeLine($event)"
							@modify-purchase="modifyPurchase($event)"
							@modify-recurring="modifyRecurringPurchase($event)"
							@renew-purchase="renewPurchase($event)"
							@show-contract-popup="displayContractPopup($event)"
							@show-society-popup="displaySocietyPopup($event)"
							@stop-loader="closeLoading()"
						/>
					</div>
				</vs-tab>
				<vs-tab label="Vue par client">
					<PurchasesCardTable
						v-if="currentTab == 1"
						:purchases="displayedPurchaseCards"
						:societyimages="displayedPurchases"
						:loading="loading"
						@delete-line="removeLine($event)"
						@modify-purchase="modifyPurchase($event)"
						@modify-recurring="modifyRecurringPurchase($event)"
						@renew-purchase="renewPurchase($event)"
						@show-contract-popup="displayContractPopup($event)"
						@show-society-popup="displaySocietyPopup($event)"
						@launch-loader="openLoading()"
						@stop-loader="closeLoading()"
					/>
				</vs-tab>
				<vs-tab label="Vue par prestataire">
					<PurchasesTableRecapProviders
						v-if="currentTab == 2"
						:apiUrl="apiUrl"
						@contract-info-popup="displayContractInfoPopup($event)"
						:purchases="displayedPurchases"
					/>
				</vs-tab>
			</vs-tabs>
		</vx-card>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import FilterCard from "@/views/filters/FilterCard";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import PurchasesTable from "@/components/tables/PurchasesTable";
import PurchasesCardTable from "@/components/tables/PurchasesCardTable";
import PurchasesTableRecapProviders from "@/components/popups/PurchasesTableRecapProviders";
import PurchasesTableRecapBudgetMediaMax from "@/components/popups/PurchasesTableRecapBudgetMediaMax";
import store from "@/store/store";
import XLSX from "xlsx";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import sortingMixin from "@/mixins/sortingMixin.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default {
	name: "PurchasesDashboard",
	mixins: [utilsMixin, sortingMixin, dbFieldConvertorMixin],
	components: {
		ContractInfoPopup,
		FilterCard,
		PurchasesCardTable,
		PurchasesTable,
		PurchasesTableRecapProviders,
		PurchasesTableRecapBudgetMediaMax,
		flatPickr,
		monthSelect,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			dates: [],
			accountManagerList: [],
			accountManagerFilter: "",
			billableFilter: "",
			dateFromFilter: new Date("1990-01-01")
				.toISOString()
				.substring(0, 10)
				.split("-")
				.reverse()
				.join("/"),
			dateToFilter: new Date()
				.toISOString()
				.substring(0, 10)
				.split("-")
				.reverse()
				.join("/"),
			contractNumberFilter: "",
			expertiseFilter: "",
			providerFilter: "",
			societyFilter: "",
			recurrenceFilter: "",
			accountManagerFilterOn: false,
			billableFilterOn: false,
			dateFromFilterOn: true,
			dateToFilterOn: true,
			contractNumberFilterOn: false,
			expertiseFilterOn: false,
			invoiceFilterOn: true,
			providerFilterOn: false,
			societyFilterOn: false,
			recurrenceFilterOn: false,
			showMaxBudgetPurchasePopup: false,
			providerOptions: [],
			displayedPurchasesFull: [],
			displayedPurchases: [],
			displayedPurchaseCards: [],
			displayedPurchasesSum: 0,
			societyImageList: [],
			selectedContract: null,
			selectedSociety: null,
			showSocietyPopup: false,
			showContractPopup: false,
			refreshKey: 0,
			frequencyOptions: [
				{ text: "One shot", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Bimestriel", value: 2 },
				{ text: "Trimestriel", value: 3 },
				{ text: "Quadrimestriel", value: 4 },
				{ text: "Semestriel", value: 5 },
				{ text: "Annuel", value: 6 },
			],
			billableOptions: [
				{ text: "Facturable", value: 1 },
				{ text: "Non-facturable", value: 0 },
			],
			configDatePicker: {
				dateFormat: "j/n/Y",
			},
			showRouterPopup: true,
			loading: false,
			loaderStyle: "",
			loaderContainerStyle: "max-height: 79vh; overflow: auto;",
			currentTab: 0,
			editFacturation: false,
			periodFilter: null,
			periodFilterOn: false,
			configPeriodPicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			actionsTemplates: [
				{
					order: 1,
					emitSlugName: "new_purchase",
					buttonName: "Nouvel Achat",
					buttonIcon: "icon-plus-circle",
					buttonColor: "primary",
				},
				{
					order: 2,
					emitSlugName: "popup_invoice",
					buttonName: this.displayBtnEditFacturation(),
					buttonIcon: "",
					buttonColor: "primary",
				},
				{
					order: 3,
					emitSlugName: "popup_budget",
					buttonName: "Consulter les achats par budget max",
					buttonIcon: "",
					buttonColor: "dark",
				},
				{
					order: 4,
					emitSlugName: "action_extract_purchases",
					buttonName: "Exporter",
					buttonIcon: "icon-download-cloud",
					buttonColor: "dark",
				},
			],
			filtersTemplates: [
				{
					order: 1,
					emitSlugName: "filter_consultant",
					filterPlaceHolder: "Ajouté par",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 2,
					emitSlugName: "filter_contract",
					filterPlaceHolder: "N° Contrat",
					value: "",
					type: "Input",
				},
				{
					order: 3,
					emitSlugName: "filter_client",
					filterPlaceHolder: "Client",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 4,
					emitSlugName: "filter_expertise",
					filterPlaceHolder: "Service",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
				{
					order: 5,
					emitSlugName: "filter_provider",
					filterPlaceHolder: "Prestataire",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
				{
					order: 6,
					emitSlugName: "filter_startDate",
					filterPlaceHolder: "Date de début",
					value: "",
					require: false,
					type: "Date",
					params: {
						date_type: "date",
					},
				},
				{
					order: 7,
					emitSlugName: "filter_endDate",
					filterPlaceHolder: "Date de fin",
					value: "",
					require: false,
					type: "Date",
					params: {
						date_type: "date",
					},
				},
				{
					order: 8,
					emitSlugName: "filter_period",
					filterPlaceHolder: "Période",
					value: "",
					require: false,
					type: "Date",
					params: {
						date_type: "period",
					},
				},
				{
					order: 9,
					emitSlugName: "filter_billable",
					filterPlaceHolder: "Facturable et Refacturable",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [
							{ name: "Facturable", id: 2 },
							{ name: "Non facturable", id: 1 },
						],
					},
				},
				{
					order: 10,
					emitSlugName: "filter_invoice",
					filterPlaceHolder: "",
					value: true,
					type: "Switch",
					params: {
						on: "Tous les achats",
						off: "Achats à rapprocher",
					},
				},
				{
					order: 11,
					emitSlugName: "filter_btn",
					value: true,
					type: "Btn",
				},
			],
			runFilter: 0,
		};
	},
	async created() {
		this.getAllPurchases();
		this.getAllSocieties();
		this.getAllCollaborators();

		this.getAllServices();
		this.getAllProviders();
		this.getAllContractsWithContractsUsers();
		if (this.$route.params.contract_id) {
			this.providerFilter = parseInt(this.$route.params.contract_id);
			this.providerFilterOn = true;
		}
	},
	mounted() {
		let style = document.createElement("link");
		style.rel = "stylesheet";
		style.href = "https://fonts.googleapis.com/icon?family=Material+Icons";
		document.head.appendChild(style);
		/*
		 * this.accountManagerFilter = (this.activeUser.id + 1)
		 * this.displayedPurchases = this.displayPurchases(this.purchases)
		 */
		this.loadFilters();
		if (this.allCollaborators.length > 0) this.createAMList();
		/*
		 * //console.log("this.purchases: ", this.purchases)
		 * this.displayedPurchasesFull = this.displayPurchases(this.purchases)
		 * //console.log("this.displayedPurchasesFull: ", this.displayedPurchasesFull)
		 * if(this.isFilterSet()){
		 *   //console.log("Filters found.")
		 *   this.displayedPurchases = this.filterPurchases(this.displayedPurchasesFull)
		 *   //console.log("this.displayedPurchases: ", this.displayedPurchases)
		 * }
		 */
	},
	watch: {
		societies: function (data) {
			this.filtersTemplates[2].params.dropdownValues = data;
			this.refreshKey++;
		},
		allCollaborators: function (data) {
			this.filtersTemplates[0].params.dropdownValues = data
				.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
				.sort((a, b) => {
					return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
				})
				.map((row) => {
					return { id: row.id, name: row.firstname + " " + row.lastname };
				});
		},
		services: function (data) {
			this.filtersTemplates[3].params.dropdownValues = data;
		},
		providers: function (data) {
			for (let p of data) p["name"] = p.society;
			this.filtersTemplates[4].params.dropdownValues = data;
		},
		purchases: function (data) {
			/*
			 * //console.log("purchases WATCH")
			 *  this.displayedPurchases = this.displayPurchases(this.purchases)
			 *  this.loadFilters()
			 *  //console.log("data: ", data)
			 */

			this.displayedPurchasesFull = this.displayPurchases(data);
			// //console.log("this.displayedPurchasesFull: ", this.displayedPurchasesFull)
			if (this.isFilterSet()) {
				// //console.log("Filters found.")
				this.displayedPurchases = this.filterPurchases(
					this.displayedPurchasesFull
				);
				this.displayedPurchasesSum = this.makeDisplayPurchaseSum(
					this.displayedPurchases
				);
				// //console.log("this.displayedPurchases: ", this.displayedPurchases)
			}

			//keeping default filter to contract id given in route params
		},
		accountManagerFilter: function () {
			if (this.accountManagerFilter == "") {
				this.accountManagerFilterOn = false;
			} else {
				this.accountManagerFilterOn = true;
			}
		},
		billableFilter: function (data) {
			if (data == "") {
				this.billableFilterOn = false;
			} else {
				this.billableFilterOn = true;
			}
		},
		contractNumberFilter: function () {
			if (this.contractNumberFilter == "") {
				this.contractNumberFilterOn = false;
			} else {
				this.contractNumberFilterOn = true;
			}
		},
		dateFromFilter: function () {
			if (this.dateFromFilter == "") {
				this.dateFromFilterOn = false;
			} else {
				this.dateFromFilterOn = true;
			}
		},
		dateToFilter: function () {
			if (this.dateToFilter == "") {
				this.dateToFilterOn = false;
			} else {
				this.dateToFilterOn = true;
			}
		},
		periodFilter: function () {
			if (this.periodFilter == "") {
				this.periodFilterOn = false;
			} else {
				this.periodFilterOn = true;
			}
		},
		expertiseFilter: function () {
			if (this.expertiseFilter == "") {
				this.expertiseFilterOn = false;
			} else {
				this.expertiseFilterOn = true;
			}
		},
		providerFilter: function () {
			if (this.providerFilter == "") {
				this.providerFilterOn = false;
			} else {
				this.providerFilterOn = true;
			}
		},
		societyFilter: function () {
			if (this.societyFilter == "") {
				this.societyFilterOn = false;
			} else {
				this.societyFilterOn = true;
			}
		},
		activeFilter: function () {
			this.activeFilterOn = true;
		},
		recurrenceFilter: function () {
			if (this.recurrenceFilter == "") {
				this.recurrenceFilterOn = false;
			} else {
				this.recurrenceFilterOn = true;
			}
		},
		loading: function (data) {
			if (data == false) {
				this.$vs.loading.close("#researchContainer > .con-vs-loading");
			}
		},
		runFilter: function () {
			this.searchAndDisplay();
		},
	},
	computed: {
		purchases: () => {
			return store.state.purchases;
		},
		societies: () => {
			return store.state.societies;
		},
		services: () => {
			return store.state.services;
		},
		providers: () => {
			return store.state.providers;
		},
		contracts: () => {
			return store.state.contracts_contracts_users;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	methods: {
		resetAllFilter() {
			this.accountManagerFilter = "";
			this.billableFilter = "";
			(this.dateFromFilter = new Date("1990-01-01")
				.toISOString()
				.substring(0, 10)
				.split("-")
				.reverse()
				.join("/")),
				(this.dateToFilter = new Date()
					.toISOString()
					.substring(0, 10)
					.split("-")
					.reverse()
					.join("/")),
				(this.contractNumberFilter = "");
			this.expertiseFilter = "";
			this.providerFilter = "";
			this.societyFilter = "";
			this.recurrenceFilter = "";
			this.accountManagerFilterOn = false;
			this.billableFilterOn = false;
			this.dateFromFilterOn = true;
			this.dateToFilterOn = true;
			this.contractNumberFilterOn = false;
			this.expertiseFilterOn = false;
			this.invoiceFilterOn = true;
			this.providerFilterOn = false;
			this.societyFilterOn = false;
			this.recurrenceFilterOn = false;
			this.showMaxBudgetPurchasePopup = false;
			this.searchAndDisplay();
		},
		createAMList() {
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId)
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					this.sortABC(
						this.allCollaborators.filter((collaborator) =>
							[3, 6, 9].includes(collaborator.type)
						),
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_client":
					this.societyFilter = receivedEmit[1].value;
					break;
				case "filter_contract":
					this.contractNumberFilter = receivedEmit[1].value;
					break;
				case "filter_expertise":
					this.expertiseFilter = receivedEmit[1].value;
					break;
				case "filter_provider":
					this.providerFilter = receivedEmit[1].value;
					break;
				case "filter_billable":
					this.billableFilter = receivedEmit[1].value;
					break;
				case "filter_startDate":
					this.dateFromFilter = receivedEmit[1].value;
					break;
				case "filter_endDate":
					this.dateToFilter = receivedEmit[1].value;
					break;
				case "filter_period":
					this.periodFilter = receivedEmit[1].value;
					break;
				case "filter_consultant":
					this.accountManagerFilter = receivedEmit[1].value;
					break;
				case "filter_invoice":
					this.invoiceFilterOn = receivedEmit[1].value;
					break;
				case "filter_btn":
					this.runFilter++;
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			switch (receivedEmit[0]) {
				case "action_extract_purchases":
					this.exportData(this.displayedPurchases);
					break;
				case "new_purchase":
					// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
					this.$router.push({ name: "new_entity" });
					break;
				case "popup_invoice":
					// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
					this.editFacturationDate();
					break;
				case "popup_budget":
					this.displayMaxBudgetPurchasePopup();
					break;
				default:
					break;
			}
		},
		displayBtnEditFacturation() {
			if (this.editFacturation) return "Valider la sélection";
			else return "Saisir la date de facturation";
		},
		editFacturationDate() {
			if (this.editFacturation) this.editFacturation = false;
			else this.editFacturation = true;
		},
		makeDisplayPurchaseSum(purchases) {
			let sum = 0;
			for (let i = 0; i < purchases.length; i++) {
				sum += purchases[i].recurrence_price
					? purchases[i].recurrence_price
					: purchases[i].price;
			}
			return sum;
		},
		getSocietyImage(societyId) {
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					if (image.data.length > 0) {
						this.societyImageList.push({
							id: societyId,
							image: image.data,
						});
					}
				})
				.catch((err) => {
					//console.log(err);
				});
		},

		buildCardData(data) {
			return new Promise((resolve) => {
				let today = new Date(Date.now());
				let strToDate =
					this.dateToFilter == ""
						? today.toISOString().substring(0, 7)
						: this.dateToFilter.split("/").reverse().join("-").substring(0, 7);
				let strFromDate = "";
				if (this.dateFromFilter == "") {
					let lastYearDate = new Date(strToDate);
					lastYearDate.setFullYear(lastYearDate.getFullYear() - 1);
					strFromDate = lastYearDate.toISOString().substring(0, 7);
				} else {
					strFromDate = this.dateFromFilter
						.split("/")
						.reverse()
						.join("-")
						.substring(0, 7);
				}

				this.dates = this.generateDateRange(strFromDate, strToDate).reverse();
				//console.log("this.dates", this.dates);
				// SORT
				let purchaseData = this.sortByArgsName(
					data,
					["contract_society_id", false],
					["bought_at", true]
				);

				// GROUP
				let displayedPurchasesData = [];
				if (purchaseData.length > 0) {
					let lastSocietyId = purchaseData[0].contract_society_id;

					// this.getSocietyImage(purchaseData[0].contract_society_id)

					displayedPurchasesData.push({
						contract_society_id: purchaseData[0].contract_society_id,
						society_image: this.getSocietyImage(
							purchaseData[0].contract_society_id
						),
						dates: this.dates,
						purchasesByMonth: [],
					});
					for (let date of this.dates) {
						displayedPurchasesData[0].purchasesByMonth.push([]);
					}

					let dateIndex = this.dates.indexOf(
						purchaseData[0].bought_at.substring(0, 7)
					);
					if (dateIndex >= 0) {
						displayedPurchasesData[
							displayedPurchasesData.length - 1
						].purchasesByMonth[dateIndex].push(purchaseData[0]);
					}

					for (let i = 1; i < purchaseData.length; i++) {
						if (purchaseData[i].contract_society_id == lastSocietyId) {
							let dateIndex = this.dates.indexOf(
								purchaseData[i].bought_at.substring(0, 7)
							);
							if (dateIndex >= 0) {
								displayedPurchasesData[
									displayedPurchasesData.length - 1
								].purchasesByMonth[dateIndex].push(purchaseData[i]);
							}
						} else {
							lastSocietyId = purchaseData[i].contract_society_id;

							this.getSocietyImage(purchaseData[i].contract_society_id);

							displayedPurchasesData.push({
								contract_society_id: purchaseData[i].contract_society_id,
								society_image: this.getSocietyImage(
									purchaseData[0].contract_society_id
								),
								dates: this.dates,
								purchasesByMonth: [],
							});

							for (let i = 0; i < this.dates.length; i++) {
								displayedPurchasesData[
									displayedPurchasesData.length - 1
								].purchasesByMonth.push([]);
							}

							let dateIndex = this.dates.indexOf(
								purchaseData[i].bought_at.substring(0, 7)
							);
							if (dateIndex >= 0) {
								displayedPurchasesData[
									displayedPurchasesData.length - 1
								].purchasesByMonth[dateIndex].push(purchaseData[i]);
							}
						}
					}
				}

				// ASSIGN

				this.displayedPurchaseCards = displayedPurchasesData;
				resolve();
			});
		},

		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},
		getAllContractsWithContractsUsers() {
			this.$store.dispatch("getAllContractsWithContractsUsers");
		},

		contractInfoPopupClosed() {
			this.showContractPopup = false;
		},

		displayContractInfoPopup(contract_id) {
			//console.log("showContractPopup");
			this.showContractPopup = true;
			this.selectedContract = this.contracts.filter(
				(contract) => contract.id == contract_id
			)[0];
		},

		displayContractPopup(contract) {
			this.$http
				.get(this.apiUrl + "contract/get/" + contract.toString())
				.then((res) => {
					//Initialisation des données pour le popup
					this.showContractPopup = true;
					let contractProp = res.data[0];
					contractProp.society_name = this.getSocietyName(
						contractProp.society_id
					);
					//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
					let ComponentClass = Vue.extend(ContractInfoPopup);
					let contractPopup = new ComponentClass({
						propsData: {
							contract: res.data[0],
							popupActive: this.showContractPopup,
							router: this.$router,
							apiUrl: this.apiUrl,
						},
					});
					contractPopup.$mount();
					contractPopup.$on("modify-contract", (contractId) => {
						this.popupActive = false;
						this.modifyContract(contractId);
					});
					contractPopup.$on("modify-missions", (contractId) => {
						this.popupActive = false;
						this.modifyMissions(contractId);
					});
					contractPopup.$on("renew-purchase", (purchaseId) => {
						this.popupActive = false;
						this.renewPurchase(purchaseId);
					});
					this.$refs.popupContainer.appendChild(contractPopup.$el);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		displaySocietyPopup(society) {
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = society;
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		displayMaxBudgetPurchasePopup() {
			this.showMaxBudgetPurchasePopup = true;
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},
		/**
		 * Fetch all the purchases
		 */
		getAllPurchases() {
			////console.log("getAllPurchases BEGIN")
			this.$store.dispatch("getAllPurchasesWithRecurring").then(() => {
				//console.log(" DONEEEEE");
			});
			////console.log("getAllPurchases END")
		},
		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName").then(() => {
				//console.log(" DONEEEEE SOCIERITE", this.societies);
			});
		},

		getAllServices() {
			this.$store.dispatch("getAllServices");
		},

		getSocietyName(societyId) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == societyId);
			/*
			 * //console.log("society")
			 * //console.log(JSON.stringify(society))
			 */
			society_name = society.name;
			return society_name;
		},

		removeLine(purchase) {
			if (purchase.recurrence_id) {
				let purchaseToDelete = this.displayedPurchasesFull.find(
					(element) => element.recurrence_id == purchase.recurrence_id
				);
				this.displayedPurchasesFull = this.displayedPurchasesFull.filter(
					function (element) {
						return element.id != purchase.id;
					}
				);
			} else {
				let purchaseToDelete = this.displayedPurchasesFull.find(
					(element) => element.id == purchase.id
				);
				this.displayedPurchasesFull = this.displayedPurchasesFull.filter(
					function (element) {
						return element.id != purchase.id;
					}
				);
			}

			this.displayedPurchases = this.displayedPurchasesFull;
			this.displayedPurchasesSum = this.makeDisplayPurchaseSum(
				this.displayedPurchases
			);
			// //console.log("removeLine")
		},

		saveFilters() {
			// //console.log("Saving filters...")
			let purchaseFilters = {
				accountManagerFilter: this.accountManagerFilter,
				billableFilter: this.billableFilter,
				contractNumberFilter: this.contractNumberFilter,
				expertiseFilter: this.expertiseFilter,
				providerFilter: this.providerFilter,
				societyFilter: this.societyFilter,
				recurrenceFilter: this.recurrenceFilter,
				dateFromFilter: this.dateFromFilter,
				dateToFilter: this.dateToFilter,
				contractNumberFilterOn: this.contractNumberFilterOn,
				expertiseFilterOn: this.expertiseFilterOn,
				invoiceFilterOn: this.invoiceFilterOn,
				providerFilterOn: this.providerFilterOn,
				societyFilterOn: this.societyFilterOn,
				recurrenceFilterOn: this.recurrenceFilterOn,
				dateFromFilterOn: this.dateFromFilterOn,
				dateToFilterOn: this.dateToFilterOn,
			};
			sessionStorage.setItem(
				"purchaseFilters",
				JSON.stringify(purchaseFilters)
			);
		},

		loadFilters() {
			// //console.log("Loading filters...")
			let purchaseFilters = JSON.parse(
				sessionStorage.getItem("purchaseFilters")
			);
			sessionStorage.removeItem("purchaseFilters");
			if (purchaseFilters) {
				this.accountManagerFilter = purchaseFilters.accountManagerFilter;
				this.billableFilter = purchaseFilters.billableFilter;
				this.contractNumberFilter = purchaseFilters.contractNumberFilter;
				this.expertiseFilter = purchaseFilters.expertiseFilter;
				this.providerFilter = purchaseFilters.providerFilter;
				this.societyFilter = purchaseFilters.societyFilter;
				this.recurrenceFilter = purchaseFilters.recurrenceFilter;
				this.dateFromFilter = purchaseFilters.dateFromFilter;
				this.dateToFilter = purchaseFilters.dateToFilter;
				this.contractNumberFilterOn = purchaseFilters.contractNumberFilterOn;
				this.expertiseFilterOn = purchaseFilters.expertiseFilterOn;
				this.providerFilterOn = purchaseFilters.providerFilterOn;
				this.invoiceFilterOn = purchaseFilters.invoiceFilterOn;
				this.societyFilterOn = purchaseFilters.societyFilterOn;
				this.recurrenceFilterOn = purchaseFilters.recurrenceFilterOn;
				this.dateFromFilterOn = purchaseFilters.dateFromFilterOn;
				this.dateToFilterOn = purchaseFilters.dateToFilterOn;
				// //console.log("Filters loaded.")
			}
		},

		newPurchase() {
			//Save filters
			if (this.isFilterSet()) {
				this.saveFilters();
			}
			this.$router.push({ name: "recurring_purchase_check" });
		},

		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},

		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},

		modifyPurchase(purchase) {
			//Save filters
			if (this.isFilterSet()) {
				this.saveFilters();
			}
			//console.log("purchase", purchase);
			this.$router.push({
				name: "update_entity",
				params: { purchaseId: purchase.id, updateEntityForm: "purchases" },
			});
		},

		modifyRecurringPurchase(purchase) {
			//Save filters
			if (this.isFilterSet()) {
				this.saveFilters();
			}
			this.$router.push({
				name: "update_entity",
				params: {
					recurrencePurchaseId: purchase.recurrence_id,
					updateEntityForm: "purchases",
				},
			});
		},

		renewPurchase(purchaseId) {
			//Save filters
			if (this.isFilterSet()) {
				this.saveFilters();
			}
			this.$router.push({
				name: "new_entity",
				params: { purchaseId: purchaseId, newEntityForm: "renewpurchase" },
			});
		},
		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (
				this.accountManagerFilterOn ||
				this.billableFilterOn ||
				this.contractNumberFilterOn ||
				this.dateFromFilterOn ||
				this.dateToFilterOn ||
				this.expertiseFilterOn ||
				this.providerFilterOn ||
				this.societyFilterOn ||
				this.recurrenceFilterOn ||
				!this.invoiceFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered purchases A CHANGER
		 * @param {String} contractNumberFilter - Contract number filter search value
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} recurrenceFilter - Recurrence's Frequency number filter search value
		 * @return {List} - Purchases' list filtered
		 */
		filterPurchases(purchases) {
			//console.log("filterProviders BEGIN");
			//console.log(this.providerFilterOn);
			//console.log(this.providerFilter);
			let purchasesList = [];

			let searchKeyList = {};
			this.accountManagerFilterOn
				? (searchKeyList["accountManagerFilter"] = this.accountManagerFilter)
				: false;
			this.billableFilterOn
				? (searchKeyList["billableFilter"] = this.billableFilter)
				: false;
			this.dateFromFilterOn
				? (searchKeyList["dateFromFilter"] = new Date(
						this.dateFromFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.dateToFilterOn
				? (searchKeyList["dateToFilter"] = new Date(
						this.dateToFilter.split("/").reverse().join("-") + " 23:59:59"
				  ))
				: false;
			this.periodFilterOn
				? (searchKeyList["periodFilter"] = this.periodFilter)
				: false;
			this.expertiseFilterOn
				? (searchKeyList["expertiseFilter"] = this.expertiseFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter)
				: false;
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] =
						this.contractNumberFilter.toString())
				: false;
			this.providerFilterOn
				? (searchKeyList["providerFilter"] = this.providerFilter)
				: false;
			this.invoiceFilterOn ? false : (searchKeyList["invoiceFilter"] = 1);
			this.recurrenceFilterOn
				? (searchKeyList["recurrenceFilter"] = this.recurrenceFilter)
				: false;
			if (this.dateFromFilter == "")
				searchKeyList["dateFromFilter"] = new Date("1990-01-01");
			if (this.dateToFilter == "") searchKeyList["dateToFilter"] = new Date();

			for (let purchaseToFilter of purchases) {
				/*
				 * //console.log(purchaseToFilter)
				 *  let society_name = this.getSocietyName(purchaseToFilter.contract_society_id)
				 */

				// if(society_name != "") society_name = society_name.toLowerCase()

				let purchaseSearchKeyList = {};
				let purchaseDate = purchaseToFilter.recurrence_date
					? purchaseToFilter.recurrence_date
					: purchaseToFilter.bought_at;
				let re = new RegExp("([T|Z])", "g");
				purchaseDate = purchaseDate ? purchaseDate.substring(0, 10) : null;
				purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
				this.dateFromFilterOn
					? (purchaseSearchKeyList["dateFromFilter"] = purchaseDate)
					: false;
				this.dateToFilterOn
					? (purchaseSearchKeyList["dateToFilter"] = purchaseDate)
					: false;

				let periodDate = purchaseToFilter.period_date
					? purchaseToFilter.period_date
							.substring(0, 10)
							.split("-")
							.reverse()
							.join("/")
							.substring(3, 10)
					: false;
				this.periodFilterOn
					? (purchaseSearchKeyList["periodFilter"] = periodDate)
					: false;

				let foundContract = this.contracts.find(
					(contract) => contract.id == purchaseToFilter.contract_id
				);
				let AMList = [];
				if (foundContract && foundContract.account_managers) {
					AMList = foundContract.account_managers.split(",");
					AMList = AMList.splice(0, AMList.length / 2);
				}
				this.accountManagerFilterOn
					? (purchaseSearchKeyList["accountManagerFilter"] =
							purchaseToFilter.user_id)
					: false;
				this.billableFilterOn
					? (purchaseSearchKeyList["billableFilter"] =
							purchaseToFilter.is_billable)
					: false;
				this.expertiseFilterOn
					? (purchaseSearchKeyList["expertiseFilter"] =
							purchaseToFilter.service_id)
					: false;
				this.societyFilterOn
					? (purchaseSearchKeyList["societyFilter"] =
							purchaseToFilter.contract_society_id)
					: false;
				this.contractNumberFilterOn
					? (purchaseSearchKeyList["contractNumberFilter"] =
							purchaseToFilter.contract_id.toString())
					: false;
				this.providerFilterOn
					? (purchaseSearchKeyList["providerFilter"] =
							purchaseToFilter.users_id)
					: false;
				this.invoiceFilterOn
					? false
					: (purchaseSearchKeyList["invoiceFilter"] =
							purchaseToFilter.invoice_date ? 2 : 1);
				this.recurrenceFilterOn
					? (purchaseSearchKeyList["recurrenceFilter"] =
							purchaseToFilter.recurrence)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof purchaseSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] === "string") {
						if (typeof purchaseSearchKeyList[key] === "string") {
							if (!purchaseSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof purchaseSearchKeyList[key] == "object") {
							let checkLoop = false;
							for (let value of purchaseSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						} else {
							check = false;
						}
					} else if (searchKeyList[key] instanceof Date) {
						let s = searchKeyList[key]
							.toISOString()
							.substring(0, 10)
							.replace(/-/g, "");
						let p = purchaseSearchKeyList[key]
							.toISOString()
							.substring(0, 10)
							.replace(/-/g, "");
						if (key == "dateFromFilter") {
							check = Number(p) - Number(s) >= 0 ? true : false;
						}
						if (key == "dateToFilter") {
							check = Number(s) - Number(p) >= 0 ? true : false;
						}
						if (!check) break;
					} else {
						if (
							purchaseSearchKeyList[key] != searchKeyList[key] &&
							key != "billableFilter"
						) {
							console.log("here");
							check = false;
							break;
						} else if (
							purchaseSearchKeyList[key] != searchKeyList[key] - 1 &&
							key == "billableFilter"
						) {
							check = false;
							break;
						}
					}
				}

				if (check) purchasesList.push(purchaseToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			// purchasesList = purchasesList.filter(purchase => purchase.period_date && purchase.period_date.split("-").map(row => parseInt(row))[0] == this.periodFilter.split("/").map(r => parseInt(r))[1] && purchase.period_date.split("-").map(row => parseInt(row))[1] == this.periodFilter.split("/").map(r => parseInt(r))[0])

			return purchasesList;
		},

		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displayPurchases(purchases) {
			////console.log("displayPurchases BEGIN")
			let purchasesList = [];
			if (this.displayedPurchases.length > 0) {
				purchasesList = this.displayedPurchases;
			} else {
				// if(!this.isFilterSet()){
				purchasesList = purchases;
				// }
			}

			// getServiceIdToName
			if (purchasesList.length > 0) {
				////console.log(purchasesList)
				purchasesList = purchasesList.filter((purchase) => {
					if (
						purchase.recurrence_is_check !== null &&
						purchase.recurrence_is_check !== undefined
					) {
						if (purchase.recurrence_is_check == 1) {
							if (purchase.recurrence_is_paid == 1) {
								return true;
							} else {
								return false;
							}
						} else {
							return false;
						}
					} else {
						return true;
					}
				});
				for (let purchase of purchasesList) {
					/*
					 * //console.log("purchase")
					 * //console.log(purchase)
					 * //console.log("purchase.service_id_list")
					 * //console.log(purchase.service_id_list)
					 */
					let service_name_list = [];
					/*
					 * //console.log("purchase.service_name_list")
					 * //console.log(purchase.service_name_list)
					 */
					if (
						purchase.service_name_list != undefined &&
						purchase.service_name_list.length > 0
					) {
						////console.log("purchase.service_name_list DEFINED")
						service_name_list = purchase.service_name_list;
					} else {
						////console.log("purchase.service_name_list UNDEFINED")
						if (
							purchase.service_id_list != undefined &&
							purchase.service_id_list.length > 0
						) {
							for (let service of purchase.service_id_list) {
								service_name_list.push(this.getServiceIdToName(service));
							}
						}
					}
					purchase.service_name_list = service_name_list;
				}
			}
			/*
			 * return result
			 * //console.log("displayPurchases END")
			 */
			return purchasesList;
		},

		async searchAndDisplay() {
			document.querySelector(".click-to-add").scrollTo(0, 0);
			await new Promise((resolve) => {
				this.displayedPurchases = this.filterPurchases(
					this.displayedPurchasesFull
				);
				this.displayedPurchasesSum = this.makeDisplayPurchaseSum(
					this.displayedPurchases
				);
				this.buildCardData(this.displayedPurchases);
				this.$forceUpdate();
				resolve();
			});
		},

		async openLoading() {
			await new Promise((resolve) => {
				this.loading = true;
				this.$vs.loading({
					container: "#researchContainer",
				});
				this.loaderContainerStyle =
					"max-height:69vh; overflow: auto; height:500px;";
				this.loaderStyle =
					"position:absolute; left:0; top:0; width:100%; height: 500px; visible:true;";
				resolve();
			});
		},

		closeLoading() {
			return new Promise((resolve) => {
				this.$vs.loading.close("#researchContainer");
				this.loaderContainerStyle = "max-height:69vh; overflow: auto;";
				this.loaderStyle = "";
				this.loading = false;
				resolve();
			});
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},
		exportData(dataIn) {
			let data = JSON.parse(JSON.stringify(dataIn));

			for (let i = 0; i < data.length; i++) {
				data[i]["recurrence"] = this.getPurchaseFrequency(
					data[i]["recurrence"]
				);
				data[i]["is_billable"] = this.getUserDashboardAccess(
					data[i]["is_billable"]
				);
				data[i]["bought_at"] = this.dateToFR(data[i]["bought_at"]);
				data[i]["input_date"] = this.dateToFR(data[i]["input_date"]);

				for (let x in data[i]) {
					data[i][x] = String(data[i][x]).trim();
				}

				this.$delete(data[i], "margin_price");
				this.$delete(data[i], "margin_rate");
				this.$delete(data[i], "is_delivered");
				this.$delete(data[i], "user_id");
				this.$delete(data[i], "users_id");
				this.$delete(data[i], "contract_society_id");
				this.$delete(data[i], "service_id");
				this.$delete(data[i], "recurrence_date");
				this.$delete(data[i], "recurrence_is_paid");
				this.$delete(data[i], "recurrence_id");
				this.$delete(data[i], "recurrence_active");
				this.$delete(data[i], "recurrence_is_check");
				this.$delete(data[i], "recurrence_price");
				this.$delete(data[i], "service_name_list");
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Achats";
			let header = {
				header: [
					"id",
					"society_name",
					"contract_id",
					"service_name",
					"provider_name",
					"price",
					"input_date",
					"bought_at",
					"recurrence",
					"is_billable",
					"commentary",
				],
				skipHeader: true,
				origin: -1,
			};
			let header_names = [
				{
					id: "Identifiant",
					society_name: "Société",
					contract_id: "Numéro de contrat",
					service_name: "Service",
					provider_name: "Prestataire",
					price: "Prix d'achat (HT)",
					input_date: "Date de Saisie",
					bought_at: "Date d'achat",
					recurrence: "Récurrence",
					is_billable: "Facturable",
					commentary: "Commentaire",
				},
			];
			//this.arrayObjectToString(data, "service_name_list", "service_name_join");

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);
			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);
			XLSX.writeFile(wb, "Achats_export.xls");
		},
	},
};
</script>
<style lang="scss">
.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
</style>